import { STATE_INITIAL } from 'Store/commonActions';

import type { ExploreState } from './types';

const initialState: ExploreState = {
  catalog: {
    fetchingStatus: STATE_INITIAL,
    catalogGroups: [],
    introModal: undefined,
    nextCatalogIds: [],
  },
  curatedRecs: {
    activeCatalogId: '',
    catalogs: {},
  },
};

export default initialState;
